export class GlobalClusterIdentifierCondition {
    'operator';
    'globalClusterIdentifier';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ScalarOperators",
            "format": ""
        },
        {
            "name": "globalClusterIdentifier",
            "baseName": "globalClusterIdentifier",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GlobalClusterIdentifierCondition.attributeTypeMap;
    }
    constructor() {
    }
}
